var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDragIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_325_1637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 18.553C11 19.653 10.1 20.553 9 20.553C7.9 20.553 7 19.653 7 18.553C7 17.453 7.9 16.553 9 16.553C10.1 16.553 11 17.453 11 18.553ZM9 10.553C7.9 10.553 7 11.453 7 12.553C7 13.653 7.9 14.553 9 14.553C10.1 14.553 11 13.653 11 12.553C11 11.453 10.1 10.553 9 10.553ZM9 4.55301C7.9 4.55301 7 5.45301 7 6.55301C7 7.65301 7.9 8.55301 9 8.55301C10.1 8.55301 11 7.65301 11 6.55301C11 5.45301 10.1 4.55301 9 4.55301ZM15 8.55301C16.1 8.55301 17 7.65301 17 6.55301C17 5.45301 16.1 4.55301 15 4.55301C13.9 4.55301 13 5.45301 13 6.55301C13 7.65301 13.9 8.55301 15 8.55301ZM15 10.553C13.9 10.553 13 11.453 13 12.553C13 13.653 13.9 14.553 15 14.553C16.1 14.553 17 13.653 17 12.553C17 11.453 16.1 10.553 15 10.553ZM15 16.553C13.9 16.553 13 17.453 13 18.553C13 19.653 13.9 20.553 15 20.553C16.1 20.553 17 19.653 17 18.553C17 17.453 16.1 16.553 15 16.553Z",
    fill: "#4D5758"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_325_1637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.553009)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDragIndicator);
export default __webpack_public_path__ + "static/media/icon-drag-indicator.029617621e405264b85dda61fb59501c.svg";
export { ForwardRef as ReactComponent };